$(document).ready(function() {
  // used by cart.liquid and page.order-reservation.liquid
  var cart_form = $('#cart_form, #reservation_form');
  if (cart_form) {
    var toggleReservationButton = function() {
      // cannot reserve if at least one enhancement or memo sample/set
      var cannot_reserve = !!$('.enhancement-line, .memo-line').length;
      
      var button = $('#reserve_order_cart');
      var parent = button.parent();
      button.prop('disabled', cannot_reserve);
      parent.attr('title', cannot_reserve ? parent.attr('data-tooltip-text') : '');
    }
    toggleReservationButton();
    
    var toggleCartTable = function(item_count) {
      $('.non-empty-cart').toggle(item_count > 0);
      $('.empty-cart').toggle(item_count == 0);
    }
    
    var changeQuantity = function(updates) {
      $.post('/cart/update.js', { updates: updates }, null, 'json')
      .done(function(data) {
        // update subtotal
        $('.subtotal_amount', cart_form).text(Shopify.formatMoney(data.total_price) + " " + data.currency);
        
        // update cart icon count
        $('#cart_count_value').text(data.items.length || "");
        
        // remove row if quantity is now zero
        for (var line_item_key in updates) {
          if (updates[line_item_key] == 0) {
            $(".cart-list-item-row[data-line-item-key='" + line_item_key + "']").remove();
          }
        }
        
        // toggle UI element visibility
        toggleCartTable(data.item_count);
        toggleReservationButton();
      })
      .fail(function(data) {
        console.log('fail', data);
        alert('Unable to modify quantity');
      });
    }
    
    // track changes to quantity fields
    $('input[type=number].quantity', cart_form).change(function() {
      var field = $(this);
      var line_item_key = field.attr('data-line-item-key');
      var quantity = field.val();
      
      var updates = {};
      updates[line_item_key] = quantity;
      changeQuantity(updates);
    });
    
    // remove item
    $('.remove-item', cart_form).click(function() {
      var updates = {};
      var line_item_unique_id = $(this).attr('data-line-item-unique-id');
      $(".cart-list-item-row[data-line-item-unique-id='" + line_item_unique_id + "']").each(function() {
        updates[$(this).attr('data-line-item-key')] = 0;
      });
      changeQuantity(updates);
    });
  }
});